export default {
    noResultsText: 'Nenhum resultado localizado',
    noChoicesText: 'Nenhuma escolha para selecionar',
    itemSelectText: 'Pressione para selecionar',
    uniqueItemText: 'Apenas valores únicos podem ser adicionados',
    customAddItemText: 'Apenas valores com a combinação específica podem ser adicionados',
    apiSearching: 'Procurando...',
    // addItemText: value => `Press Enter to add <b>"${sanitise(value)}"</b>`,
    // maxItemText: maxItemCount => `Only ${maxItemCount} values can be added`,
    customChoiceValue: 'Outro',
}
